import FieldNames from "../defaults/FieldNames.json";
import Query from "@arcgis/core/rest/support/Query";
import StatisticDefinition from "@arcgis/core/rest/support/StatisticDefinition.js";

export const baseFilter = getBaseFilterString();

export const createQueryObject = (useGeometry, whereClause, numberToTakeEachTime, startIndex, geometry, outfields, maxCount=null) => {
  if(useGeometry)
  {
    return new Query({
      where: whereClause,
      orderByFields: "OBJECTID DESC",
      outFields: outfields,
      returnGeometry: false,
      num: numberToTakeEachTime,
      start: startIndex,
      geometry: geometry,
      inSR: 102100,
      spatialRel: 'esriSpatialRelIntersects',
      resultRecordCount: maxCount
    });
  }
  else
  {
    return new Query({
      where: whereClause,
      orderByFields: "OBJECTID DESC",
      outFields: outfields,
      returnGeometry: false,
      num: numberToTakeEachTime,
      start: startIndex,
      resultRecordCount: maxCount
    });
  }
}

export const createDistinctQueryObject = (useGeometry, whereClause, geometry, outfields) => {
  // Should never be more than 2k possible values
  if(useGeometry)
  {
    return new Query({
      where: whereClause,
      outFields: outfields,
      returnGeometry: false,
      geometry: [geometry],
      inSR: 102100,
      returnDistinctValues: true,
    });
  }
  else
  {
    return new Query({
      where: whereClause,
      outFields: outfields,
      returnGeometry: false,
      returnDistinctValues: true
    });
  }
}

export const createPagedQueryObject = (useGeometry, whereClause, numberToTakeEachTime, startIndex, geometry, outfields) => {
  if(useGeometry)
  {
    return new Query({
      where: whereClause,
      orderByFields: "OBJECTID DESC",
      outFields: outfields,
      returnGeometry: false,
      num: numberToTakeEachTime,
      start: startIndex,
      geometry: geometry,
      inSR: 102100,
      spatialRel: 'esriSpatialRelIntersects',
    });
  }
  else
  {
    return new Query({
      where: whereClause,
      orderByFields: "OBJECTID DESC",
      outFields: outfields,
      returnGeometry: false,
      num: numberToTakeEachTime,
      start: startIndex,
    });
  }
}
export const createQueryObjectForEstimatedTotalCost = (useGeometry, whereClause, numberToTakeEachTime, startIndex, geometry, statOutFieldCostName = "AllEstimatedTotalCost", statOutFieldAcresName = "AllEstimatedTotalAcres") => {
  let totalStatCostDefinition = new StatisticDefinition({
    onStatisticField: FieldNames.featureFields.estimatedTotalCost,
    outStatisticFieldName: statOutFieldCostName,
    statisticType: "sum"
  });
  let totalStatAcresDefinition = new StatisticDefinition({
    onStatisticField: FieldNames.featureFields.calculatedArea,
    outStatisticFieldName: statOutFieldAcresName,
    statisticType: "sum"
  });

  if(useGeometry)
  {
    return new Query({
      where: whereClause,
      orderByFields: statOutFieldCostName + " DESC",
      returnGeometry: false,
      num: numberToTakeEachTime,
      start: startIndex,
      geometry: geometry,
      inSR: 102100,
      spatialRel: 'esriSpatialRelIntersects',
      groupByFieldsForStatistics: [FieldNames.featureFields.fundingSourceCategory],
      outStatistics: [totalStatCostDefinition, totalStatAcresDefinition]
    });
  }
  else
  {
    return new Query({
      where: whereClause,
      orderByFields: statOutFieldCostName + " DESC",
      returnGeometry: false,
      num: numberToTakeEachTime,
      start: startIndex,
      groupByFieldsForStatistics: [FieldNames.featureFields.fundingSourceCategory],
      outStatistics: [totalStatCostDefinition, totalStatAcresDefinition]
    });
  }
}

// The current known way to query for the count of features that fit a query
// https://community.esri.com/t5/arcgis-enterprise-questions/arcgis-server-record-count-query-with-spatial/td-p/530692
export const createCountQueryObject = (useGeometry, whereClause, numberToTakeEachTime, startIndex, geometry, outfields, statOutFieldName = "featureCount") => {
  let statDefinition = new StatisticDefinition({
    onStatisticField: "OBJECTID",
    outStatisticFieldName: statOutFieldName,
    statisticType: "count"
  });

  if(useGeometry)
  {
    return new Query({
      where: whereClause,
      orderByFields: statOutFieldName + " DESC",
      outFields: outfields,
      returnGeometry: false,
      num: numberToTakeEachTime,
      start: startIndex,
      geometry: geometry,
      inSR: 102100,
      spatialRel: 'esriSpatialRelIntersects',
      outStatistics: [statDefinition],
      groupByFieldsForStatistics: [FieldNames.featureFields.class]
    });
  }
  else
  {
    return new Query({
      where: whereClause,
      orderByFields: statOutFieldName + " DESC",
      outFields: outfields,
      returnGeometry: false,
      num: numberToTakeEachTime,
      start: startIndex,
      outStatistics: [statDefinition],
      groupByFieldsForStatistics: [FieldNames.featureFields.class]
    });
  }
}
export function getBaseFilterString() {
  return "(OBJECTID IS NOT NULL)";
}

export function getBasePostFireString() {
  return "(EntityType = 'PostFire')"
} 

export function getBaseFuelsString(){
  return "(EntityType = 'Fuels')"
}
